import { useFetch } from "../../../hooks/fetch-data/config";
import { DownloadAttachment } from "../../../services/modules/loan";

const RECEIPT_FILE_NAME = "receipt";

export function useFetchInstallmentReceipt({ loanId, installmentName }) {
  return useFetch({
    queryKeys: ["installmentReceipt", loanId, installmentName],
    queryFn: async () => {
      const blobUrl = await DownloadAttachment({
        body: {
          loan_id: Number(loanId),
          installment_id: Number(installmentName),
          file_name: RECEIPT_FILE_NAME,
        },
      });
      return blobUrl;
      
    },
    
    enabled: Boolean(installmentName) && Boolean(loanId),
  });
}
